import React from 'react';
import { Typography } from '@forgeglobal/design-framework';
import InfoCard from '@tcs/common/components/molecules/InfoCard';
import { useStyles } from './style';

interface Props {
  title: string;
  content: string;
  description?: string;
}

const InfoItem = ({ title, content, description }: Props) => {
  const classes = useStyles();

  return (
    <InfoCard title={title}>
      <Typography
        variant="h3"
        color="primary"
        component="h2"
        data-private
        className={classes.itemContent}>
        {content}
      </Typography>
      {description && (
        <Typography variant="caption" color="textSecondary">
          {description}
        </Typography>
      )}
    </InfoCard>
  );
};

export default InfoItem;
